import { Injectable, inject } from '@angular/core';
import { environment } from '../../environments/environment';
import { ICallToAction, IUiYearMonth } from '../models';
import { ConfigService } from './config.service';

@Injectable({
  providedIn: 'root',
})
export class LghfAnalyticsService {
  private readonly configService = inject(ConfigService);

  public callToAction(
    currentStep: string, lendingType?: string, loanAmount?: number, mortgageTermMonth?: IUiYearMonth,
  ): void {
    const msg: ICallToAction = {
      currentStep,
      lendingType,
      loanAmount,
      mortgageTermMonth,
    };

    if (environment.production) {
      window.parent.postMessage(msg, this.configService.config.lghfUrl);
    }
  }
}
